import React from "react";

const Holidays = () => {
  return (
    <div className="container mt-4">
      <h4>Holidays</h4>

      <div className="card p-3">
        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Date</th>
              <th>Description</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {[1,2,3].map(i => (
              <tr key={i}>
                <td>New Year</td>
                <td>14 Jan</td>
                <td>Holiday</td>
                <td><span className="badge bg-success">Active</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Holidays;